import { FC } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MDSLoadingDotsProps, MDSLoadingDotsSize } from "./loading-dots.types";
import { StyledLoadingDotsContainer } from "./loading-dots.styles";
import loadingDotsAnimation from "@/assets/images/loading-dots-tomato.json";

export const MDSLoadingDots: FC<MDSLoadingDotsProps> = ({
  size = MDSLoadingDotsSize.Medium,
  className,
  loop = true,
  speed = 1.0,
}) => {
  return (
    <StyledLoadingDotsContainer size={size} className={className}>
      <DotLottieReact
        data={loadingDotsAnimation}
        loop={loop}
        autoplay
        speed={speed}
        style={{ width: "100%", height: "100%" }}
      />
    </StyledLoadingDotsContainer>
  );
};
